<p>edit-price-templates works!</p>
